module.exports = __webpack_public_path__ + "images/8095a65.png";